import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface GenericListItem {
    id: number;
    name: string;
}

const ReportSalesByBranchAndProductGroupSummaryData = (props: RouteComponentProps<{}>) => {
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [loading, setLoading] = React.useState(true);
    const [branchId, setBranchId] = React.useState(-1);
    const [branchOptions, setBranchOptions] = React.useState<GenericListItem[]>([]);
    const [productGroupId, setProductGroupId] = React.useState(-1);
    const [productGroupOptions, setProductGroupOptions] = React.useState<GenericListItem[]>([]);

    React.useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=RunReports&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                //get dropdowns
                axios.get('api/Job/GetAllBranches', {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                })
                .then(res => {
                    setBranchOptions(res.data);
                    getProductGroups(token ?? "");
                })
                .catch(error => {
                    toast.error(error.message);
                });
            } else if (res.data == false) {
                //redirect to 403 permission denied
                props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const getProductGroups = (token: string) => {
        axios.get('api/Report/GetProductGroups', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            setProductGroupOptions(res.data);
            setLoading(false);
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const handleBranchIdChange = (e: any) => {
        let error = errors;
        delete error["branchId"];
        setErrors(error);
        var branchIdValue = e.target.value * 1;
        setBranchId(branchIdValue);
    }

    const handleProductGroupIdChange = (e: any) => {
        let error = errors;
        delete error["productGroupId"];
        setErrors(error);
        var prodGrpIdValue = e.target.value * 1;
        setProductGroupId(prodGrpIdValue);
    }

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;

        if (branchId < 1) {
            formIsValid = false;
            errorList["branchId"] = "Branch is required";
        }

        if (productGroupId < 1) {
            formIsValid = false;
            errorList["productGroupId"] = "Product Group is required";
        }

        setErrors(errorList);
        return formIsValid;
    }

    const runReport = (e: any) => {
        e.preventDefault();
        //run the report and export the data

        if (validate()) {
            runRpt();
        }
    }

    const runRpt = () => {
        var url = "/report/SalesByBranchAndProductGroupSummaryReport/-1/-1/" + branchId + "/" + productGroupId + "/-1";
        window.open(url, '_blank');
    }

    const exportReport = (e: any) => {
        e.preventDefault();

        if (validate()) {
            exportRpt();
        }
    }

    const exportRpt = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios("api/Report/ExportSalesByBranchAndProductGroupSummaryReportData?BranchId=" + branchId + "&ProductGroupId=" + productGroupId + "&subId=" + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'GET',
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "SalesByBranchAndProductGroupSummary.xlsx");
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const renderDetails = (
        <div>
            <div>
                <h1>Sales by Branch and Product Group Summary Report</h1>
            </div>
            <div className="marginTop20">
                <span>Select a Branch and Product Group to run the report. </span>
            </div>
            <div>
                <label className="input-group" htmlFor="branchId">
                    <span className="label">Branch</span>
                    <select className="select" id="branchId" name="branchId" value={branchId} onChange={(e) => handleBranchIdChange(e)}>
                        <option defaultValue="-1" value="-1"></option>
                        {branchOptions.map(branch =>
                            <option key={branch.id} value={branch.id}>{branch.name}</option>
                        )};
                    </select>
                </label>
                <span className={errors["branchId"] ? "label errors marginLeftLabel" : "hidden"}>{errors["branchId"]}</span>

                <label className="input-group" htmlFor="productGroupId">
                    <span className="label">Product Group</span>
                    <select className="select" id="productGroupId" name="productGroupId" value={productGroupId} onChange={(e) => handleProductGroupIdChange(e)}>
                        <option defaultValue="-1" value="-1"></option>
                        {productGroupOptions.map(productGroup =>
                            <option key={productGroup.id} value={productGroup.id}>{productGroup.name}</option>
                        )};
                    </select>
                </label>
                <span className={errors["productGroupId"] ? "label errors marginLeftLabel" : "hidden"}>{errors["productGroupId"]}</span>
            </div>
            <button className="defaultbutton marginLeftLabel marginRight10" type='button' onClick={runReport}>Run Report</button>
            <button className="defaultbutton" type='button' onClick={exportReport}>Export to Excel</button>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (<div>
        {contents}
    </div>)

};

export default ReportSalesByBranchAndProductGroupSummaryData;